import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MessageService } from 'primeng/api';
import { concat, from, of, Subscription, Observable, Subject } from 'rxjs';
import { map, concatMap, switchMap } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { FilterService } from 'primeng/api';
import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';

import { Product, ProductInfo } from 'src/app/shared/product'

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { ProductApiService } from 'src/app/services/product-api.service';

class InTransitRow {

  PRODCODE: string;
  PRODID: number;
  DOCITEMQTY: number;
  PRODWAITQNTY: number;
  DOCITEMTEXT1: string;
  DOCITEMTEXT2: string;
  DOCID: number;
  DOCDATE: Date;
  DOCEXPDATE: Date;
  DOCVALDATE: Date;
  DOCNAMESTR: string;
  DOCNAME1: string;
  DOCNOTE1: string;
  DOCNOTE2: string;
  VENDORNAME: string;
  LOCALCOMP: string;

};

@Component({
  selector: 'app-product-list-in-transit',
  templateUrl: './product-list-in-transit.component.html',
  styleUrls: ['./product-list-in-transit.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ProductListInTransitComponent implements OnInit, OnDestroy, OnChanges {
  private globalSettinsData: GlobalSettingsData;

  rows: number = 20;
  totalRecords: number;
  loading: boolean = false;

  cf1: string;
  cf2: number;
  cf3: number;
  cf4: string;
  cf5: string;
  cf6: string;
  cf7: string;
  cf8: string;
  cf9: string;
  cf10: string;
  cf11: string;

  monthToLoad: number = 12;

  inTransitList: InTransitRow[];

  @ViewChild('inTransitTable') inTransitTable: Table;

  selectedRow: InTransitRow;     // single Selection mode

  private _productQuery: Subscription;
  private _prodRowQuery: Subscription;

  private listOptions$ = new Subject<number>();

  constructor(
    private prodApi: ProductApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private messageService: MessageService,
    private filterService: FilterService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** ProductListInTransitComponent ngOnChanges: enter');
    //environment.production || console.table(changes);
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** ProductListInTransitComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** ProductListInTransitComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'prodId':
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** ProductListInTransitComponent in ngOnDestroy')

    if (this._productQuery) { this._productQuery.unsubscribe(); }

    if (this._prodRowQuery) { this._prodRowQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** ProductListInTransitComponent in ngOnInit')

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    //environment.production || console.table(this.columns);

    this._productQuery =
      this.listOptions$
        .pipe(switchMap(depth => this.prodApi.getProductsInTransit(depth)))
        .subscribe(data => {
          this.inTransitList = [];

          from(data).pipe(map(pr => {

            // Convert from string to date format

            pr.DOCDATE = new Date(pr.DOCDATE);
            pr.DOCVALDATE = new Date(pr.DOCVALDATE);
            pr.DOCEXPDATE = new Date(pr.DOCEXPDATE);

            if ((pr.DOCITEMTEXT1 || '') != '') {
              pr.DOCVALDATE = new Date(pr.DOCITEMTEXT1);
              pr.DOCEXPDATE = new Date(pr.DOCVALDATE.getFullYear(), pr.DOCVALDATE.getMonth(), pr.DOCVALDATE.getDate() + 14,);
            }

          })).subscribe();

          this.inTransitList = [... data];

          this.totalRecords = data.length;

          console.log('*** ProductListInTransitComponent onInitTableLoads records: ' + this.totalRecords);
        });

    this.loading = true;
    this.listOptions$.next(this.monthToLoad);
  }

  clearOrResetTableFilter(event) {
    console.log('*** ProductListInTransitComponent clearOrResetTableFilter: ' + JSON.stringify(event));

    this.monthToLoad = 12;

    this.selectedRow = null;

    this.cf1 = '';
    this.cf2 = null;
    this.cf3 = null;
    this.cf4 = '';
    this.cf5 = '';
    this.cf6 = '';
    this.cf7 = '';
    this.cf8 = '';
    this.cf9 = '';
    this.cf10 = '';
    this.cf11 = '';

    this.inTransitTable.clearState();
    this.inTransitTable.clear();

    this.loading = true;
    this.listOptions$.next(this.monthToLoad);
  }

  onSlideEnd(event) {
    console.log('*** ProductListInTransitComponent onSlideEnd: ' + event.value)

    this.loading = true;
    this.listOptions$.next(this.monthToLoad);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

      saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  onExportData() {
    console.log('*** EditDocumentContentComponent onExportData: ')

    import("xlsx").then(xlsx => {

      environment.production || console.table(this.inTransitList);

      const exportData: any =
        this.inTransitList.map(e => ({

          'Код товара': e.PRODCODE,
          'В транзите': e.PRODWAITQNTY,
          'Заказано': e.DOCITEMQTY,
          'Отгрузка': e.DOCEXPDATE,
          'Ожидается': e.DOCVALDATE,
          'Документ': e.DOCNAMESTR,
          'Дата': e.DOCDATE,
          'Поставщик': e.VENDORNAME,
          'Получатель': e.LOCALCOMP,
          'Примечание получателя': e.DOCNOTE1,
          'Примечание поставщика': e.DOCNOTE2,

        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { products: worksheet }, SheetNames: ['products'] };

      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

      this.saveAsExcelFile(excelBuffer, "products");
    });
  }
}
